import styled, { css } from 'styled-components';
import { InsuranceIcon } from '@sainsburys-tech/bolt-icons';
var ProductSummaryListContainer = styled.ul.withConfig({
  displayName: "ProductSummarystyles__ProductSummaryListContainer",
  componentId: "tb7lax-0"
})(["display:flex;flex-direction:column;"]);
var ProductThumbnailContainer = styled.span.withConfig({
  displayName: "ProductSummarystyles__ProductThumbnailContainer",
  componentId: "tb7lax-1"
})(["display:flex;height:80px;"]);
var ProductListItem = styled.li.withConfig({
  displayName: "ProductSummarystyles__ProductListItem",
  componentId: "tb7lax-2"
})(["display:flex;flex-direction:row;align-items:center;padding:15px;"]);
var ProductThumbnailImage = styled.img.withConfig({
  displayName: "ProductSummarystyles__ProductThumbnailImage",
  componentId: "tb7lax-3"
})(["width:80px;height:100%;background:", ";"], function (props) {
  return props.theme.color.monochrome.white;
});
var ProductThumbnailSVG = styled(InsuranceIcon).withConfig({
  displayName: "ProductSummarystyles__ProductThumbnailSVG",
  componentId: "tb7lax-4"
})(["margin:16px;background:", ";"], function (props) {
  return props.theme.color.monochrome.white;
});
var ProductTitle = styled.span.withConfig({
  displayName: "ProductSummarystyles__ProductTitle",
  componentId: "tb7lax-5"
})(["margin:0 10px;line-height:normal;p{font-size:", ";line-height:normal;margin-top:10px;}", ""], function (props) {
  return props.theme.font.size.caption;
}, function (props) {
  return css(["@media only screen and (max-width:", "){margin:0 5px;}"], props.theme.size.breakpoint['max-width']['2xs']);
});
var Each = styled.span.withConfig({
  displayName: "ProductSummarystyles__Each",
  componentId: "tb7lax-6"
})(["font-size:", ";line-height:14px;"], function (props) {
  return props.theme.font.size.caption;
});
var ProductPrice = styled.span.withConfig({
  displayName: "ProductSummarystyles__ProductPrice",
  componentId: "tb7lax-7"
})(["flex-grow:1;min-width:110px;text-align:right;line-height:normal;font-weight:", ";> span{display:block;}", ""], function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return css(["@media only screen and (max-width:", "){min-width:65px;}"], props.theme.size.breakpoint['max-width'].xs);
});
var TotalPriceContainer = styled.div.withConfig({
  displayName: "ProductSummarystyles__TotalPriceContainer",
  componentId: "tb7lax-8"
})(["display:flex;justify-content:space-between;border-top:1px solid ", ";margin:0 15px;padding:15px 0;"], function (props) {
  return props.theme.color.monochrome.light;
});
var TotalPrice = styled.span.withConfig({
  displayName: "ProductSummarystyles__TotalPrice",
  componentId: "tb7lax-9"
})(["font-size:20px;font-weight:", ";text-align:right;"], function (props) {
  return props.theme.font.weight.bold;
});
export { ProductSummaryListContainer, ProductThumbnailContainer, ProductListItem, ProductThumbnailImage, ProductThumbnailSVG, ProductTitle, ProductPrice, TotalPriceContainer, TotalPrice, Each };